/**
 * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  {
    name: 'vehicle-rules',
    path: '/vehicle-rules/index',
    component: () =>
      import(
        /* webpackChunkName: "TestReceivedOrder" */ '@/views/vehicle-rules/index'
      ),
    meta: { title: '用车规则' },
  },
  {
    name: 'use-rules',
    path: '/vehicle-rules/rules',
    component: () =>
      import(/* webpackChunkName: "useRules" */ '@/views/vehicle-rules/rules'),
    meta: { title: '用车规则' },
  },
];
